import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import GalleryWidgetWrapper from './GalleryWidget'
import { GalleryWidget } from './types'
import GalleryContentContext from '@contexts/galleryContent'
import useIsInArticleContent from '@hooks/useIsInArticleContent'
import useIsInScribbleContent from '@hooks/useIsInScribbleContent'
import useIsInStoryTellingContent from '@hooks/useIsInStoryTellingContent'
import StretchContext from '@contexts/storyTellingFullWidth'
import useIsInRecipeContent from '@hooks/useIsInRecipeContent'

const Gallery: FunctionComponent<GalleryWidget> = (props) => {
  const { fullwidth } = props
  const isInArticle = useIsInArticleContent()
  const isInScribble = useIsInScribbleContent()
  const isInStoryTelling = useIsInStoryTellingContent()
  const isInRecipe = useIsInRecipeContent()
  const shouldStretchToCardWidth = isInRecipe
  const shouldStretch = isInArticle && !isInScribble && !isInRecipe
  const shouldStretchToHeaderWidth = isInStoryTelling && !!fullwidth
  return (
    <GalleryContentContext.Provider value={true}>
      <StretchContext.Provider
        value={{
          shouldStretch,
          shouldStretchToHeaderWidth,
          shouldStretchToCardWidth,
        }}>
        <GalleryWidgetWrapper {...props} />
      </StretchContext.Provider>
    </GalleryContentContext.Provider>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'gallery'],
  component: Gallery,
}

export default widget
